var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "border-bottom btn-group flex-flex" },
    [
      _c(
        "ib-row",
        [
          _c(
            "ib-button",
            {
              staticClass: "ml-0 text-center tabs",
              class: {
                active: _vm.selectedTab === "products",
                wid: !_vm.$media.s,
              },
              on: {
                click: function ($event) {
                  return _vm.setTabValue("products")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("products")))]
          ),
          _c(
            "ib-button",
            {
              staticClass: "ml-0 text-center tabs",
              class: {
                active: _vm.selectedTab === "exchanges",
                wid: !_vm.$media.s,
              },
              on: {
                click: function ($event) {
                  return _vm.setTabValue("exchanges")
                },
              },
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("exchanges")))])]
          ),
          _c(
            "ib-button",
            {
              staticClass: "ml-0 text-center tabs",
              class: {
                active: _vm.selectedTab === "contracts",
                wid: !_vm.$media.s,
              },
              on: {
                click: function ($event) {
                  return _vm.setTabValue("contracts")
                },
              },
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("contracts")))])]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }